import Axios from 'axios';
import {
  getItemNames,
  setItemNames,
  getItemCategories,
  setItemCategories,
  getStates,
  setStates,
  getLicenseNumbers,
  setLicenseNumbers,
  getQuantityTypes,
  setQuantityTypes,
  getPackageIds,
  setPackageIds,
} from './actions';
import config from '../../../common/config';

export const requestGetItemNames = (search) => (dispatch) => {
  dispatch(getItemNames(search));
  return Axios.get(`${config.apiBaseUrl}/item-names`, {
    params: search,
  }).then(({ data: itemNames }) => dispatch(setItemNames(itemNames)));
};

export const requestGetItemCategories = (search) => (dispatch) => {
  dispatch(getItemCategories(search));
  return Axios.get(`${config.apiBaseUrl}/item-categories`, {
    params: search,
  }).then(({ data: itemCategories }) =>
    dispatch(setItemCategories(itemCategories))
  );
};

export const requestGetStates = (search) => (dispatch) => {
  dispatch(getStates(search));
  return Axios.get(`${config.apiBaseUrl}/states`, {
    params: search,
  }).then(({ data: states }) => dispatch(setStates(states)));
};

export const requestGetLicenseNumbers = (search) => (dispatch) => {
  dispatch(getLicenseNumbers(search));
  return Axios.get(`${config.apiBaseUrl}/license-numbers`, {
    params: search,
  }).then(({ data: licenseNumbers }) =>
    dispatch(setLicenseNumbers(licenseNumbers))
  );
};

export const requestGetQuantityTypes = (search) => (dispatch) => {
  dispatch(getQuantityTypes(search));
  return Axios.get(`${config.apiBaseUrl}/quantity-types`, {
    params: search,
  }).then(({ data: quantityTypes }) =>
    dispatch(setQuantityTypes(quantityTypes))
  );
};

export const requestGetPackageIds = (search) => (dispatch) => {
  dispatch(getPackageIds(search));
  return Axios.get(`${config.apiBaseUrl}/package-ids`, {
    params: search,
  }).then(({ data: packageIds }) =>
    dispatch(setPackageIds(packageIds))
  );
};